import React from 'react';
//import icons
import { Facebook, Instagram, Twitter, Youtube, Heart } from 'react-feather';

const Footer = () => {
  return (
    <footer className="footer mt-auto w-full px-4 py-8 text-white" style={{
      background: "linear-gradient(45deg, #80b4f6 20%, #6c21dc 80%)"
    }}>
      <div className="w-full">
        <div className="upper">
          <h3 className="text-white text-xl font-semibold uppercase">
            MAPPT
          </h3>
          <div className="social">
            <Facebook size={25} className="icon" />
            <Instagram size={25} className="icon" />
            <Twitter size={25} className="icon" />
            <Youtube size={25} className="icon" />
          </div>
        </div>
        <div className="lower">
          <div className="left">
            <ul>
              <li>Privacy & Terms</li>
              <li>Policy</li>
              <li>Help Center</li>
              <li>Partnership</li>
              <li>Contact</li>
            </ul>
          </div>
          <div className="right">
            <ul>
              <li>&copy; 2022 MAPPT. All rights reserved.</li>
              <a
                href="https://github.com/itsdannywarner"
                target="_blank"
                className="flex justify-center hover:text-white cursor-pointer transition-all ease-in duration-500"
              >
                <li className="inline-flex">
                  Built by Danny
                </li>
              </a>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
